import { CompassContextType } from '@/src/libs/CompassContext';
import { Compare, Marker } from '@/types';

import { areFiltersActive } from './areFiltersActive';

export const shouldShowMarkerAndMeetings = (
  markers: Marker[],
  ctx: CompassContextType
) => {
  if (!ctx || !markers?.length) return [];

  const { day, type, time } = ctx.state.filters;
  const filtersActive = areFiltersActive(ctx);

  return markers.map((marker) => {
    if (!filtersActive) {
      marker.meetings.forEach((meeting) => (meeting.display = true));
      marker.marker.map = ctx.state.map;
      return marker;
    }

    let hasVisibleMeeting = false;

    marker.meetings.forEach((meeting) => {
      const matchesFilters =
        (day.length === 0 || day.includes(meeting.day)) &&
        (type.length === 0 || type.includes(meeting.type)) &&
        isWithinTimeFrame(
          parseInt(meeting.time),
          time.compare,
          parseInt(time.value)
        );

      meeting.display = matchesFilters;
      if (matchesFilters) hasVisibleMeeting = true;
    });

    marker.marker.map = hasVisibleMeeting ? ctx.state.map : null;
    return marker;
  });
};

const isWithinTimeFrame = (time: number, compare: Compare, value: number) => {
  if (!time || !compare) return true;
  if (compare === '<') {
    return time < value;
  }
  if (compare === '>=') {
    return time >= value;
  }
  if (compare === '=') {
    return time === value;
  }
  return true;
};
